import * as pageTypeHelpers from './pageTypes';

export const typeWhenOnCaseOrEngineMetrics = (_state, pageType) => {
  const condition = pageType === pageTypeHelpers.CASEMETRICS ||
    pageType === pageTypeHelpers.ENGINEMETRICS;
  return condition ? pageType.type : '';
};


// WEBPACK FOOTER //
// src/helpers/selectors.js